import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
  productsInit: false,
};

const reducers = {
  getProducts(state, action) {
    const products = action.payload;
    state.products = products;
    state.productsInit = true;
  },
};

export const slice = createSlice({
  name: "order",
  initialState,
  reducers,
});

export const { reducer } = slice;
